import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export interface InternalNavCounts {
  clubs: number;
  stadiums: number;
  kiosks: number;
  /** Every portal IDSeat can open: clubs + stadiums + kiosks (no query of its own). */
  workspaces: number;
  events: number;
  languages: number;
}

/**
 * Cheap head/count queries for the internal-admin sidebar badges. Kept separate
 * from useInternalOverview so the shell (rendered on every page) stays light.
 */
export function useInternalNavCounts(enabled: boolean) {
  return useQuery<InternalNavCounts>({
    queryKey: ["internal-nav-counts"],
    enabled,
    staleTime: 60_000,
    queryFn: async () => {
      const [clubs, stadiums, kiosks, events, languages] = await Promise.all([
        supabase.from("clubs").select("id", { count: "exact", head: true }).is("deleted_at", null),
        supabase.from("stadiums").select("id", { count: "exact", head: true }),
        supabase.from("operators").select("id", { count: "exact", head: true }),
        supabase.from("events").select("id", { count: "exact", head: true }),
        supabase.from("supported_languages").select("code", { count: "exact", head: true }),
      ]);
      return {
        clubs: clubs.count ?? 0,
        stadiums: stadiums.count ?? 0,
        kiosks: kiosks.count ?? 0,
        workspaces: (clubs.count ?? 0) + (stadiums.count ?? 0) + (kiosks.count ?? 0),
        events: events.count ?? 0,
        languages: languages.count ?? 0,
      };
    },
  });
}
